'use client'

import { useFetch } from 'hooks/useFetch/useFetch'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { env } from 'utils/envManager'

export function useSendRecoveryPassword() {
	const { fetcher } = useFetch()
	const { country, isShop } = useMasterData()

	const sendEmailRecoveryPassword = async (email: string) => {
		const { countryISO, languageISO } = country
		const channel = isShop ? 'shop' : 'outlet'

		try {
			await fetcher({
				url: `${env.NEXT_PUBLIC_API_DOMAIN}/ws/0/customer-orchestrator/v1/account/resetpwd/send?countryIso=${countryISO}&languageIso=${languageISO}&channelId=${channel}`,
				method: 'POST',
				body: { email },
			})
			return { success: true }
		} catch (error) {
			return { success: false }
		}
	}

	return { sendEmailRecoveryPassword }
}
